import React from 'react';

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export function Wrapper({ children, className }: PageWrapperProps) {
  return (
    <main className={`flex flex-col items-center justify-center ${className}`}>
      <article className="md:w-[1030px] md:px-0 px-4 w-full mt-[52px]">{children}</article>
    </main>
  );
}
